import { zodResolver } from "@hookform/resolvers/zod";
import Button from "../../../../../../../../library/button";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { schema, UpdatePasswordSchema } from "./schema";
import { ButtonsWrapper, Field, Form } from "./styled";
import { useForm } from "react-hook-form";
import { Label } from "../../../../../../../../library/label";
import Input from "../../../../../../../../library/input";
import useUpdatePassword from "../../../../../../../../hooks/useUpdatePassword";

interface Props {
  onSuccess: () => void;
  onError: () => void;
}

const EditModal = ({ onSuccess, onError }: Props) => {
  const { updatePassword } = useUpdatePassword();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<UpdatePasswordSchema>({ resolver: zodResolver(schema) });

  const updatepassword = async (data: UpdatePasswordSchema) => {
    try {
      const update = await updatePassword(data);
      if (update?.error === null) {
        onSuccess();
      } else {
        throw update.error;
      }
    } catch (e) {
      onError();
    }
  };

  return (
    <Form onSubmit={handleSubmit(updatepassword)}>
      <Field>
        <Label htmlFor="name">Passord</Label>
        <Input
          register={register}
          name="password"
          error={errors["password"]}
          variant="regular"
          placeholder="Passord"
          type="password"
        />
      </Field>
      <Field>
        <Label htmlFor="name">Passord igjen</Label>
        <Input
          register={register}
          name="passwordRetype"
          error={errors["passwordRetype"]}
          variant="regular"
          placeholder="Passord igjen"
          type="password"
        />
      </Field>
      <ButtonsWrapper>
        <Button color="grey" variant="regular" spacing="right">
          Avbryt
        </Button>
        <Button
          disabled={isSubmitting}
          type="submit"
          color="blue"
          variant="regular"
        >
          {isSubmitting ? (
            <>{getIcon("spinner")} Oppdaterer..</>
          ) : (
            <>Endre passord</>
          )}
        </Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default EditModal;
